import * as ReduxObservable from 'redux-observable'
import { filter, mapTo } from 'rxjs/operators'
import includes from 'lodash/includes'

/**
 * This function takes action types as arguments and emits true when it has received every one of them
 * @returns True or false depending on whether all actionTypes were received or not
 */

export default function afterAllTypes (...types: string[]) {

  /** Make an immutable array of the passed in arguments/types to check for */
  const keys = [ ...types ]

  /** Create a mutable copy of the arguments/types */
  let pending = [...keys]
  const caughtActions: any[] = []

  return function (source: ReduxObservable.ActionsObservable<{ type: string }>) {

    return source.pipe(
      filter(function (_ref) {

        /** No types have been passed so automatically succeed */
        if (keys.length === 0) return true

        /** All types have occurred and we've sent success already,
         * so auto fail to prevent it firing again */
        if (pending.length === 0) return false

        const type = _ref.type

        /** Capture the action and payload for the future */
        if (includes(pending, type)) caughtActions.push(_ref)
        pending = pending.filter(item => item !== type || keys.indexOf(type) === -1)

        return pending.length === 0

      }),
      mapTo(caughtActions)
    )

  }

}
